/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {
  // Add custom code below this line
async function validateMembershipCode() {
  console.log("Validating Membership Code");
  await fetch("/cart.js")
    .then((res) => res.json())
    .then(async (data) => {
      const discountExists = data.discount_codes.some(
        (item) => item.code.toUpperCase() === "MEMBER15"
      );
      // 42037573255239
      const membershipProductIDs = [42037384282183, 42037511651399];
      const hasMembershipProduct = data.items.some((item) =>
        membershipProductIDs.includes(item.variant_id)
      );
      const hasMembershipGift = data.items.some((item) =>
        item.variant_id === 42037573255239
      );
      if(hasMembershipProduct && document.querySelector(".membership__upsell")){
        document.querySelector(".membership__upsell").style.display = "none";
      }

      // Remove the discount if membership product is not in cart
      if (discountExists && !hasMembershipProduct) {
        document.cookie =
          "discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
         await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {"42037573255239": 0},
            discount: "",
          }),
        })
          .then((res) => res.json())
          .then((cart) => {
            console.log("Discount removed:", cart);
            document.dispatchEvent(
              new CustomEvent("theme:cart:refresh", {
                detail: {
                  target: "coupon_validate",
                },
                bubbles: true,
              })
            );
            
          })
          .catch((error) => {
            console.error("Error removing discount:", error);
          });
      }

      // Add membership gift if Membership Product Exists
      if(!hasMembershipGift && hasMembershipProduct){
         await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "items": [{id: 42037573255239, quantity: 1}],
          }),
        })
          .then((res) => res.json())
          .then((cart) => {
            console.log("Discount removed:", cart);
            document.dispatchEvent(
              new CustomEvent("theme:cart:refresh", {
                detail: {
                  target: "coupon_validate",
                },
                bubbles: true,
              })
            );
            if(window.location.pathname !== "/collections/all"){
              window.location.href="/";
            }
          })
          .catch((error) => {
            console.error("Error removing discount:", error);
          });
      }

      // Apply the discount if the membership product is in the cart
      if (!discountExists && hasMembershipProduct) {
        document.cookie = "discount_code=MEMBER15; path=/";
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {"42037573255239": 1},
            discount: "MEMBER15",
          }),
        })
          .then((res) => res.json())
          .then((cart) => {
            console.log("Discount applied:", cart);
            document.dispatchEvent(
              new CustomEvent("theme:cart:refresh", {
                detail: {
                  target: "coupon_validate",
                },
                bubbles: true,
              })
            );
          })
          .catch((error) => {
            console.error("Error applying discount:", error);
          });
      }
    });
  }
  validateMembershipCode();
  document.addEventListener("theme:cart:change", validateMembershipCode);
  // document.addEventListener("theme:cart:add", validateMembershipCode);
  // document.addEventListener("theme:cart:toggle", validateMembershipCode);
  // document.addEventListener("theme:cart-drawer:open", validateMembershipCode);
  // document.addEventListener("theme:cart-drawer:close", validateMembershipCode);


 async function updateCartStatus() {
    const cart = await fetch("/cart.js").then((r) => r.json());
    const membershipIds = [42037384282183, 42037511651399, 42037573255239];
    const hasMembershipProduct = cart.items.filter(
      (item) => membershipIds.includes(item.id)
    ).length > 0;
    // A customer can checkout if they have at least one non-membership item
    const canCheckout = cart.items.filter(
      (item) => !membershipIds.includes(item.id)
    ).length;

    if(hasMembershipProduct && document.querySelector(".membership__upsell")){
        document.querySelector(".membership__upsell").style.display = "none";
      }

    if (!canCheckout) {
      // Disable checkout button
      document
        .querySelectorAll('button[name="checkout"]')
        .forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
          btn.style.opacity = "0.5";
          btn.style.pointerEvents = "none";
          btn.parentElement.innerHTML =
        `<p style='color:red; font-size: 12px; text-align: center;'>Add at least 1 product to your order to join the U Collective</p>${btn.outerHTML}`;
        });

      // Show warning
      const drawer = document.querySelector(".drawer__foot");
      if (drawer && drawer.querySelector(".warning-message")) {
        drawer.querySelector(".warning-message").innerText =
          "This product cannot be purchased on its own. Please add another item to proceed.";
      }
    } else {
      // Enable checkout button
      document
        .querySelectorAll('button[name="checkout"]')
        .forEach((btn) => {
          btn.removeAttribute("disabled");
          btn.style.opacity = "1";
          btn.style.pointerEvents = "auto";
          btn.parentElement.innerHTML =btn.outerHTML;
        });

      // Remove warning
      const drawer = document.querySelector(".drawer__foot");
      if (drawer && drawer.querySelector(".warning-message")) {
        drawer.querySelector(".warning-message").innerText = "";
      }
    }
  }
  updateCartStatus();
  document.addEventListener("theme:cart:change", updateCartStatus);
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
// })();
